import styled from "styled-components";
import { media, theme } from "../../theme/theme";
import { LEFT_SIDE_MENU_WIDTH } from "../../layout/SideBarLayout/SidebarLayout.styles";
import { V3Button } from "../Button";

export const UniversalAddContentPositioner = styled.div<{ $skipDefaultBreakpoints?: boolean }>`
    position: fixed;
    bottom: 24px;
    background: transparent;
    cursor: pointer;
    z-index: 2;
    transform: translateX(-50%);
    left: 50%;

    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        margin-left: ${LEFT_SIDE_MENU_WIDTH / 2}px;
    }
`;

export const DropShadowBtnAddContent = styled(V3Button)`
    filter: drop-shadow(rgba(0, 0, 0, 0.06) 0px 1px 6px) drop-shadow(rgba(0, 0, 0, 0.16) 0px 2px 32px);
    &:hover {
        cursor: pointer;
        box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.2);
    }
`;